<template>
  <b-form>
    <b-row>
      <b-col>
        <b-form-group
          id="fieldsetNane"
          :label-cols="3"
          breakpoint="md"
          label="Name:"
          label-for="inputName"
        >
          <b-form-input
            id="inputName"
            name="inputName"
            v-validate="'required'"
            type="text"
            v-model="filter.filter_friendly_name"
            data-vv-as="Name"
            placeholder="Filter Name"
            ref="FilterName"
            :disabled="true"
            maxlength="50"
          ></b-form-input>
          <span class="text-danger">{{ errors.first('inputName') }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <VItemList
          listLabel="NDCs:"
          itemValidation="digits:11"
          itemValidationName="NDC"
          itemPlaceholder="Enter 11 digit NDC"
          :items="filter.filter_ndc_numbers"
          :isReadonly="isReadonly"
          @add="addNDC"
          @remove="removeNDC"
        ></VItemList>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <VItemList
          listLabel="OCC Drug Names:"
          itemPlaceholder="Enter Drug Name"
          :items="filter.occ_drug_names"
          :isReadonly="isReadonly"
          @add="addOCCDrugName"
          @remove="removeOCCDrugName"
        ></VItemList>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-left">
        <b-form-group
          id="fieldSetWraparound"
          :label-cols="3"
          breakpoint="md"
          label="Enable Claim Wraparound:"
          label-for="checkBoxWraparound"
        >
          <b-form-checkbox
            id="checkBoxWraparound"
            name="checkBoxWraparound"
            v-model="filter.claim_wraparound_enabled"
            class="customCheckH"
          >
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import VItemList from "@/components/VItemList";
export default {
  name: "VCopayEPAFilterItem",
  components: {
    VItemList
  },
  props: {
    filter: {
      required: true,
      type: Object
    },
    isReadonly: {
      required: false,
      type: Boolean
    }
  },
  methods: {
    addNDC(ndc) {
      this.filter.filter_ndc_numbers.push(ndc);
    },
    removeNDC(index) {
      this.filter.filter_ndc_numbers.splice(index, 1);
    },
    addOCCDrugName(drugName) {
      this.filter.occ_drug_names.push(drugName);
    },
    removeOCCDrugName(index) {
      this.filter.occ_drug_names.splice(index, 1);
    }
  }
};
</script>

<style lang="scss">
#filterLongPlainText {
  word-wrap: break-word;
  max-height: 400px;
  overflow: auto;
}
.customCheckH {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  padding-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/VCopayEPAFilterItemHorizon.vue